import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import ScrollToPlugin from "gsap/ScrollToPlugin";

export function industryCardsStack() {
  gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

  const cardsWrapper = document.querySelector(".industry-cards-wrapper");
  const isReduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (!cardsWrapper) return;

  const cards = gsap.utils.toArray(".industry-card");
  const cardOffset = 70;
  const mm = gsap.matchMedia();

  const getCardParam = () => {
    const params = new URLSearchParams(window.location.search);
    const cardParam = params.get("industry-card");
    return cardParam ? parseInt(cardParam, 10) : null;
  };

  if (isReduceMotion) {
    const cardIndex = getCardParam();
    if (cardIndex === null) return;
    const card = document.querySelector(`[data-card-index="${cardIndex}"]`);
    if (!card) return;
    card.querySelector(".card-title").focus();
    card.scrollIntoView({ behavior: 'auto', block: 'start' });
    return;
  }

  let hasScrolledToCard = false;

  const scrollToCardFromParam = () => {
    if (hasScrolledToCard) return;

    const cardIndex = getCardParam();
    if (cardIndex === null) return;

    const target = cards[cardIndex - 1];
    if (!target) return;

    let scrollTop;

    const trigger = ScrollTrigger.getById(cardIndex);

    if (trigger) {
      scrollTop = trigger.start;
    } else {
      scrollTop = target.offsetTop;
    }

    gsap.to(window, {
      scrollTo: { y: scrollTop },
      duration: 1,
      ease: "power1.out",
      onComplete: () => {
        target.querySelector(".card-title").focus({ preventScroll: true });
      }
    });

    hasScrolledToCard = true;
  };

  window.addEventListener("load", scrollToCardFromParam);

  // Scroll after GSAP refresh to ensure all pins are calculated
  ScrollTrigger.addEventListener("refresh", scrollToCardFromParam);

  mm.add("(min-width: 1024px)", () => {
    const cardHeight = cards[0].offsetHeight;

    cards.forEach((card, index) => {
      ScrollTrigger.create({
        trigger: card,
        start: `top top+=${cardOffset * index}`,
        endTrigger: cardsWrapper,
        end: `bottom top+=${cardHeight + cardOffset * (cards.length - 1)}px`,
        pin: true,
        scrub: 0.5,
        invalidateOnRefresh: true,
        anticipatePin: 0.2,
        id: index + 1,
      });
    });

    ScrollTrigger.refresh();

    return () => ScrollTrigger.getAll().forEach(st => st.kill());
  });
}
